import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import { TextField, FormControl } from "@mui/material"

// @mui/icons-material
import Clear from "@mui/icons-material/Clear";
import Check from "@mui/icons-material/Check";

// core components
import stylesFunction from "../../assets/jss/material-dashboard-react/components/customTextAreaStyle.js";
import { getBaseSxStyle, getKeyArray } from "../../utils/getSxStyle.js";


export default function CustomTextArea(props) {
  const styles = stylesFunction();

  const { formControlProps, labelText, id, inputProps, error, success } = props;

  const rootData = {
    "root": true,
    "marginTop": labelText === undefined,
    "labelRootError": error,
    "labelRootSuccess": success && !error
  };
  const rootKeys = getKeyArray(rootData);


  return (
    <FormControl
      {...formControlProps}
      sx={getBaseSxStyle(styles, ['formControl'])}
    >
      <TextField
        {...inputProps}
        sx={getBaseSxStyle(styles, [...rootKeys])}
        id={id}
        variant="outlined"
        multiline={true}
        error={error}
        label={labelText}
        rows={4}
      />
      {
        error
          ? (<Clear sx={getBaseSxStyle(styles, ['feedback', 'labelRootError'])} />)
          : success
            ? (<Check sx={getBaseSxStyle(styles, ['feedback', 'labelRootSuccess'])} />)
            : null
      }
    </FormControl>
  );
}
CustomTextArea.propTypes = {
  labelText: PropTypes.node,
  labelProps: PropTypes.object,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  formControlProps: PropTypes.object,
  error: PropTypes.bool,
  success: PropTypes.bool,
};
